/**
 * Dialog: crear una nómina especial/extra agrupando facturas seleccionadas
 * (de cualquier nómina actual).
 *
 * Iter 236.n (Carlos): pedido explícito — permitir crear "nóminas especiales"
 * sacando facturas de las nóminas existentes, sin afectar el flujo normal.
 * Se pueden crear varias nóminas especiales si se repite la operación con
 * distintas selecciones.
 */
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { DatePickerInput } from '../../ui/date-picker';

export function BatchNominaEspecialDialog({ open, busy, count, onClose, onCrear }) {
  const [nombre, setNombre] = useState('');
  const [fechaPago, setFechaPago] = useState('');
  const [observaciones, setObservaciones] = useState('');

  const handleSubmit = () => {
    if (!nombre.trim()) return;
    onCrear({
      nombre: nombre.trim(),
      fecha_pago: fechaPago || null,
      observaciones: observaciones || '',
    });
    // reset local
    setNombre('');
    setFechaPago('');
    setObservaciones('');
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-md" data-testid="dialog-batch-nomina-especial">
        <DialogHeader>
          <DialogTitle>
            Crear nómina manual con {count} factura{count === 1 ? '' : 's'}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          <p className="text-xs text-muted-foreground">
            Crea una nómina manual y mueve las facturas seleccionadas hacia ella.
            Las facturas pueden venir de cualquier nómina existente. Podés repetir
            esta operación para armar varias nóminas manuales.
          </p>
          <div>
            <Label className="text-xs" htmlFor="nomina-especial-nombre">
              Nombre de la nómina <span className="text-red-500">*</span>
            </Label>
            <Input
              id="nomina-especial-nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej: Nómina manual gastos urgentes"
              data-testid="input-nomina-especial-nombre"
            />
          </div>
          <div>
            <Label className="text-xs">Fecha de pago (opcional)</Label>
            <DatePickerInput
              value={fechaPago}
              onChange={setFechaPago}
              data-testid="datepicker-nomina-especial"
            />
            <p className="text-[10px] text-muted-foreground mt-1">
              Si no se indica, la nómina queda sin fecha (como "Atrasadas").
            </p>
          </div>
          <div>
            <Label className="text-xs" htmlFor="nomina-especial-obs">Observaciones</Label>
            <Input
              id="nomina-especial-obs"
              value={observaciones}
              onChange={(e) => setObservaciones(e.target.value)}
              placeholder="Opcional"
              data-testid="input-nomina-especial-obs"
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button
              variant="outline"
              size="sm"
              onClick={onClose}
              disabled={busy}
              data-testid="btn-nomina-especial-cancelar"
            >
              Cancelar
            </Button>
            <Button
              size="sm"
              disabled={!nombre.trim() || busy}
              onClick={handleSubmit}
              data-testid="btn-nomina-especial-crear"
            >
              {busy ? 'Creando…' : 'Crear nómina'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
